import { WORDPRESS_API } from "shared/constants/api";

export const dentalOffice = {
  title: "Gabinet stomatologiczny",
  description:
    "Gabinet stomatologiczny dla uczniów CKZiU w Wyrzysku (zlokalizowany przy Zespole Szkół Teatralnych w Pile)",
  address: [
    "Gabinet Stomatologiczny dla dzieci i młodzieży",
    "Piła, ul. Teatralna 1"
  ],
  phone: "785 281 818",
  website: "http://www.regionalne-centrum-stomatologii.pl"
};

export const healthDocuments = [
  {
    id: "informacja-dla-rodzicow",
    title: "Informacje dla Rodziców",
    href: `/assets/doc/health/Informacja-dla-rodzicow.pdf`
  },
  {
    id: "zgoda-sprzeciw-opieka-stomatologiczna",
    title: "Zgoda lub sprzeciw wobec opieki profilaktycznej",
    href: `/assets/doc/health/Zgoda-Sprzeciw.pdf`
  },
  {
    id: "ulotka",
    title: "Ulotka informacyjna",
    href: `${WORDPRESS_API}/wp-content/uploads/2019/03/ulotka_szkoly_pila.pdf`
  },
];